/*
 * @Author: ZS
 * @Date: 2020-06-05 15:30:42
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-14 10:33:14
 * @Description: file content
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store';
import './assets/iconfont/iconfont.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
import VueCookies from 'vue-cookies'
import {ywtbRequest, request} from './api/axios'
import publicJs from './publicMethod.js';

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
Vue.prototype.ywtbRequest = ywtbRequest
Vue.use(VueCookies)
Vue.prototype.publicJs = publicJs;
// blur方法去掉前后空格
const vBlurTrimFunc = (el, binding, vnode) => {
  const textarea = el.querySelector("textarea");
  const text = el.querySelector("input[type='text']");
  const num = el.querySelector("input[type='number']");
  const func = function(e) {
    const val = e.target.value;
    e.target.value = String(val).trim();
    vnode.child.handleBlur();
    vnode.child.$emit("input", e.target.value);
  };
  textarea && textarea.addEventListener("blur", func);
  text && text.addEventListener("blur", func);
  num && num.addEventListener("blur", func);
};
Vue.directive("blurTrim", {
  bind: vBlurTrimFunc,
  update: vBlurTrimFunc
});
// 下载
Vue.prototype.globalDownload = (param) => {
  const {
		method = "get", url = "", data = {}, blank = "_blank"
	} = param;
	let str = "";
	for (const key in data) {
		str += `<input name='${key}' value='${data[key]}' type="hidden" />`;
	}
	const form = document.createElement("form");
	form.action = url;
	form.method = method;
	form.target = blank;
	form.style.display = "none";
	document.body.appendChild(form);
	form.innerHTML = str;
	form.submit();
	window.removeFormFunc(form);
	// document.body.removeChild(form);
};
// 日期格式化
Vue.prototype.globalDateFormat = param => {
  let { time = "", format = "yyyy-MM-dd" } = param; // eslint-disable-line
  const _this = new Date(time);
  const o = {
    "M+": _this.getMonth() + 1, // 月份
    "d+": _this.getDate(), // 日
    "h+": _this.getHours(), // 小时
    "m+": _this.getMinutes(), // 分
    "s+": _this.getSeconds(), // 秒
    "q+": Math.floor((_this.getMonth() + 3) / 3), // 季度
    S: _this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (_this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
};
// 增加访问次数
Vue.prototype.globalAddVisit = (guidelineCode) => {
  // let sc = document.createElement("script");
  // sc.src = "/portal-ywtb/web/guidelineVisit/addVisit?guidelineCode=" + guidelineCode;
  // document.body.appendChild(sc);
  // document.body.removeChild(sc);
  request({
    url: "/portal-ywtb/web/guidelineVisit/addVisit?guidelineCode=" + guidelineCode
  });
}
router.beforeEach((to, from, next) => {
  // store.commit('changeLogin')
  ywtbRequest('/portal-ywtb/web/getSession').then(res=> {
    localStorage.setItem("res", JSON.stringify(res))
    store.commit('changeLogin')
    if (to.meta.requireAuth) { // 需要权限,进一步进行判断
      if (store.state.isLogin) { //
        if (to.path === "/workbench") {
          // 判断是否有不是学生角色的角色
          let list = res.data.listRole;
          for (let item of list) {
            if (Number(item.roleFlag) !== 1) {
              // 不是学生
              next();
              return;
            }
          }
          if (list.length === 0) {
            // 没有角色
            next();
            return;
          }
          // 是学生，不让进入我的工作台，进入个人中心
          next("/user");
          return;
        }
        next();
      } else { //如果没有权限,重定向到登录页,进行登录
        //  next()
        top.window.location = '/portal-ywtb/web/login?url=' + location.href;
        return;
      }
    } else { //不需要权限 直接跳转
      next();
    }
  })
  //  if (to.meta.requireAuth) { // 需要权限,进一步进行判断
  //    if (store.state.isLogin) { //
  //      next();
  //    } else { //如果没有权限,重定向到登录页,进行登录
  //     //  next()
  //    window.location.href = '/portal-ywtb/web/login'
  //     return;
  //    }
  //  } else { //不需要权限 直接跳转
  //    next();
  //  }
  /**
   * @description 解决bug ID1006567  检索中心的滚动问题
   * @author cjs
   * @date 2021-06-29 11:22:33
   */
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js